const defaultRender = (value) => (value ? value : '--');

const cellsColumn = [
    {
        title: 'File Name',
        dataIndex: 'name',
        render: (value) => <p className="capitalize">{value}</p>,
    },
    {
        title: "File No.",
        dataIndex: "file_number",
        render: defaultRender,
    },
    {
        title: "Email",
        dataIndex: "email",
        render: defaultRender,
    },
    {
        title:'Billed Amount',
        dataIndex: 'amount',
        render: (value) => {
        const amount = parseFloat(value);
        return <p>${!isNaN(amount) ? amount.toFixed(2) : '0.00'}</p>;
        },
    },
    {
        title:'Transferred Amount',
        dataIndex: 'transfer_amount',
        render: (value) => <p>${value}</p>,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Date Created',
        dataIndex: 'created_at',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
    },
];

export default cellsColumn;